export const M_STATUS = {
  1: {
    color: 'grey',
    text: 'Draft',
  },
  2: {
    color: 'warning',
    text: 'Akan Tayang',
  },
  3: {
    color: 'success',
    text: 'Sedang Tayang',
  },
  4: {
    color: 'info',
    text: 'Selesai',
  },
  5: {
    color: 'red',
    text: 'Non-aktif',
  },
}

export default {
  M_STATUS,
}

export const M_PETUNJUK = [
  {
    label: 'Kuesioner 1x Tayang',
    desc: `Tipe kuesioner 1x Tayang memungkinkan pengguna untuk mengisi <b>kuesioner sekali tanpa pengulangan</b> pada waktu yang telah di tentukan`,
    example: `Dibutuhkan Kuisioner yang diharapkan di isi oleh responden <b>Sekali Saja</b>, responden dapat mengisi kuisioner pada tanggal 22 Febuari pukul 00:00 s/d 22 Oktober 2023 pukul 12:00.`,
    waktu: `Pengguna dapat mengatur rentang waktu tayang kuesioner dengan 2 input masa berlaku kuesioner. Kuesioner akan tampil pada rentang waktu yang telah ditentukan.`,
    img: 'https://cdn.siap.id/s3/masook/asset%20img/SIM/img_sekali_tayang.png',
    imgExample: `https://cdn.siap.id/s3/masook/asset%20img/SIM/img_bulanan_a.png`,
  },
  {
    label: `Kuesioner Harian`,
    desc: `Tipe kuesioner Harian memungkinkan pengguna untuk mengisi <b>kuesioner secara berulang setiap harinya</b> pada jam yang telah ditentukan hingga masa berlaku kuesioner selesai.`,
    example: `Dibutuhkan Kuisioner yang diharapkan di isi oleh responden <b>Selama 8 Bulan</b>, responden dapat mengisi kuisioner <b>Setiap Hari pukul 07:00 s/d pukul 15:00.</b>`,
    waktu: `Masa berlaku kuesioner digunakan untuk mengatur masa aktif kuesioner, sedangkan durasi kuesioner ditayangkan digunakan untuk mengatur penayangan di aplikasi setiap hari pada jam yang telah ditentukan`,
    img: `https://cdn.siap.id/s3/masook/asset%20img/SIM/img_harian.png`,
    imgExample: `https://cdn.siap.id/s3/masook/asset%20img/SIM/img_harian_a.png`,
  },
  {
    label: `Kuisioner Mingguan`,
    desc: `Tipe kuesioner Mingguan memungkinkan pengguna untuk mengisi <b>kuesioner secara berulang setiap 1 minggu sekali</b>, pada rentang hari yang ditentukan hingga masa berlaku kuesioner selesai.`,
    example: `Dibutuhkan Kuisioner yang diharapkan di isi oleh responden Selama <b>1 Tahun</b>, responden dapat mengisi kuisioner hanya pada <b>rentang hari Jumat pukul 15:00 s/d Senin pukul 12:00.</b>`,
    waktu: `Masa berlaku kuesioner digunakan untuk mengatur masa aktif kuesioner, sedangkan durasi kuesioner ditayangkan digunakan untuk mengatur penayangan di aplikasi pada hari dan jam yang telah ditentukan`,
    img: `https://cdn.siap.id/s3/masook/asset%20img/SIM/img_mingguan.png`,
    imgExample: `https://cdn.siap.id/s3/masook/asset%20img/SIM/img_mingguan_a.png`,
  },
  {
    label: `Kuisioner Bulanan`,
    desc: `Tipe kuesioner Bulanan memungkinkan pengguna untuk mengisi <b>kuesioner secara berulang setiap 1 bulan sekali</b>, pada rentang hari yang ditentukan hingga masa berlaku kuesioner selesai.`,
    example: `Dibutuhkan Kuisioner yang diharapkan di isi oleh responden Selama <b>1 Tahun</b>, responden dapat mengisi kuisioner hanya pada <b>rentang hari Jumat pukul 15:00 s/d Senin pukul 12:00.</b>`,
    waktu: `Masa berlaku kuesioner digunakan untuk mengatur masa aktif kuesioner, sedangkan durasi kuesioner ditayangkan digunakan untuk mengatur penayangan di aplikasi pada hari dan jam yang telah ditentukan`,
    img: `https://cdn.siap.id/s3/masook/asset%20img/SIM/img_bulanan.png`,
    imgExample: `https://cdn.siap.id/s3/masook/asset%20img/SIM/img_sekali_tayang_a.png`,
  },
]
